module.exports = __webpack_public_path__ + "img/u560.76f33438.png";